import hasErrorFactory from '../../../controllers/add-company/has-error';
import completeInvoiceNumberFactory from '../../../controllers/add-bank-account/complete-invoice-number';
export default function otpDirektController($scope, pageContext) {
	var $ctrl = this;

	window.dataLayer = window.dataLayer || [];
	$ctrl.pageContext = pageContext;
	$ctrl.$scope = $scope;
	$ctrl.serviceNotAvailable = false;
	$ctrl.hasError = hasErrorFactory($ctrl, 'direktForm');
	$ctrl.completeInvoiceNumber = completeInvoiceNumberFactory($ctrl);
	$ctrl.otpDirektLoginClicked = false;

	$ctrl.otpLogin = {};

	$ctrl.otpDirektLogin = function () {
		if (angular.isDefined($ctrl.otpDirektLoginFunction)) {
			$ctrl.otpDirektLoginClicked = true;
			$ctrl.otpDirektLoginFunction({ successCallback: $ctrl.successCallback });
		}
	};

	$ctrl.noOtpDirekt = function () {
		if (angular.isDefined($ctrl.noOtpDirektFunction)) {
			$ctrl.noOtpDirektFunction();
			window.dataLayer.push ({
				'event': 'bAccLinkStatus',
				'linkStatus': 'No Link'
			});
		}
	};

	$ctrl.onHideOtpDirektLogin = function () {
		if (angular.isDefined($ctrl.hideOtpDirektLogin)) {
			$ctrl.hideOtpDirektLogin();
		}
	};

	if ($ctrl.pageContext.hasOwnProperty('mw_szamla')) {
		$ctrl.otpLogin.invoiceNumber = $ctrl.pageContext.mw_szamla;
	}
}
